// components/SEO.jsx
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  keywords = '안전관리, 산업안전보건법, 안전법규, 안전교육, 안전관리자',
  structuredData = null,
  noIndex = false,
}) => {
  const siteUrl = (process.env.REACT_APP_SITE_URL || 'https://safety-academy.kr').replace(/\/$/, '');
  const toAbsoluteUrl = (value) => {
    if (!value) return siteUrl;
    if (/^https?:\/\//i.test(value)) return value;
    return `${siteUrl}${value.startsWith('/') ? value : `/${value}`}`;
  };
  const fullUrl = toAbsoluteUrl(url);
  const fullImage = toAbsoluteUrl(image || '/assets/HeroSection_Logo.jpg');
  const robots = noIndex ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{title || '안전사관학교 - 안전관리자의 역량 강화 플랫폼'}</title>
      <meta name="description" content={description || '안전관리자의 역량 강화와 전문성 향상을 위한 교육 플랫폼. 산업안전보건법, 법령 조항, 질의회시를 한 곳에서 확인하세요.'} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="안전사관학교" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title || '안전사관학교 - 안전관리자의 역량 강화 플랫폼'} />
      <meta property="og:description" content={description || '안전관리자의 역량 강화와 전문성 향상을 위한 교육 플랫폼'} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="안전사관학교" />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title || '안전사관학교 - 안전관리자의 역량 강화 플랫폼'} />
      <meta name="twitter:description" content={description || '안전관리자의 역량 강화와 전문성 향상을 위한 교육 플랫폼'} />
      <meta name="twitter:image" content={fullImage} />

      {/* 추가 메타 태그 */}
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* 구조화된 데이터 (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;

